import { ShieldCheck } from 'lucide-react';

import { NodeShell } from './NodeShell';

export const RunQualityNode = ({
  data,
  selected,
}: {
  data: { label: string; outputKey?: string };
  selected?: boolean;
}) => (
  <NodeShell
    type="run_quality"
    icon={<ShieldCheck size={16} />}
    label={data.label}
    subtitle={data.outputKey ? `→ ${data.outputKey}` : undefined}
    selected={selected}
  />
);
